import { all, fork } from "redux-saga/effects";
import Loginsaga from "./Login/saga";
import Usersaga from "./User/saga";
import Categoriessaga from "./Categories/saga";
import Productssaga from "./Products/saga";
import mycartsaga from "./Mycart/saga";

export default function* rootSaga() {
  yield all([fork(Loginsaga),fork(Usersaga),fork(Categoriessaga),fork(Productssaga),fork(mycartsaga)]);
}
